import { Box, Typography } from "@mui/material";
import React from "react";
import AntSwitch from "./AntSwitch";
import {
  ASSIGNABLE_FRAMEWORKS,
  setFramework,
} from "../shared/constants/frameworks";

interface FrameworkSwitchesProps {
  value: string[];
  onChange: (next: string[]) => void;
}

// One switch per compliance checklist an organisation can be given (for example DoT).
const FrameworkSwitches: React.FC<FrameworkSwitchesProps> = ({
  value,
  onChange,
}) => (
  <>
    <Typography variant="body2" fontWeight="bold" marginTop={3}>
      Compliance Frameworks
    </Typography>
    {ASSIGNABLE_FRAMEWORKS.map((framework) => (
      <Box
        key={framework.value}
        sx={(theme) => ({
          display: "flex",
          height: 40,
          marginTop: 1,
          alignItems: "center",
          bgcolor: theme.palette.mode === "dark" ? "#181818" : "#f5f5f5",
          width: "100%",
          borderRadius: 2,
          justifyContent: "space-between",
        })}
      >
        <Typography variant="body2" sx={{ ml: 2, fontWeight: 500 }}>
          {framework.label}
        </Typography>
        <div style={{ marginRight: 10 }}>
          <AntSwitch
            checked={value.includes(framework.value)}
            onChange={(event) =>
              onChange(setFramework(value, framework.value, event.target.checked))
            }
            inputProps={{ "aria-label": framework.label }}
          />
        </div>
      </Box>
    ))}
  </>
);

export default FrameworkSwitches;
